import {useStore} from 'vuex'

export default {
    name: "PostAside",
    setup(){
        const store = useStore()
        const startUserInfoOverlay = function(e, userId){
            store.commit('main/set_page_overlay_content_data', {
                userId
            })
            store.dispatch('main/openPageOverlay',{
                overlayContent: 'MemberOverlay',
                returnTarget: e.currentTarget
            })            
        }

        return {
            startUserInfoOverlay
        }
    }
}